import React from 'react';
import { ArrowLeft, Edit2, Save, X, User } from 'lucide-react';
import { Button } from '../../SubscriptionAppButton';
import { Badge } from '../../SubscriptionAppBadge';
import { getStatusVariant } from '../../../data/mockSubscriptionData';
export interface SubscriptionHeaderProps {
  subscription: any;
  isEditing: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onBack: () => void;
  onViewContact?: () => void;
  isSaveDisabled?: boolean;
  hasChanges?: boolean;
}
export function SubscriptionHeader({
  subscription,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  onBack,
  onViewContact,
  isSaveDisabled = false,
  hasChanges = false
}: SubscriptionHeaderProps) {
  if (!subscription) return null;
  return <div className="mb-6" data-id="element-3201">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-3202">
        <div className="flex items-center gap-4" data-id="element-3203">
          <button onClick={onBack} className="flex items-center justify-center w-10 h-10 rounded-md border border-[#CBD5E1] bg-white hover:bg-[#F8FAFC] transition-colors" data-id="element-3204">
            <ArrowLeft className="w-5 h-5 text-[#475569]" data-id="element-3205" />
          </button>
          <div data-id="element-3206">
            <div className="flex items-center gap-3 mb-1" data-id="element-3207">
              <h1 className="text-2xl font-semibold text-[#0F172A]" data-id="element-3208">
                {subscription.id}
              </h1>
              {!isEditing && <Badge variant={getStatusVariant(subscription.status)} data-id="element-3209">
                  {subscription.status}
                </Badge>}
            </div>
            <p className="text-sm text-[#64748B]" data-id="element-3210">
              {subscription.customerName} | {subscription.customer}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3" data-id="element-3211">
          {isEditing ? <>
              <Button variant="outline" onClick={onCancel} iconLeft={<X size={16} data-id="element-3213" />} data-id="element-3212">
                Cancel
              </Button>
              <Button variant="primary" onClick={onSave} iconLeft={<Save size={16} data-id="element-3215" />} disabled={!hasChanges} data-id="element-3214">
                Save Changes
              </Button>
            </> : <>
              {onViewContact && <Button variant="outline" onClick={onViewContact} iconLeft={<User size={16} data-id="element-3217" />} data-id="element-3216">
                  View Contact Details
                </Button>}
              <Button variant="primary" onClick={onEdit} iconLeft={<Edit2 size={16} data-id="element-3219" />} data-id="element-3218">
                Edit
              </Button>
            </>}
        </div>
      </div>
    </div>;
}